// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hi-0";